import React,  { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'
import SelectObjectComponent from '../../../components/select_objects'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class ModalSelectObject extends Component{

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    _userSelectObject = (objects) => {
        this.props.dismiss()
        this.props.updateSelectedObject([])
        this.props.updateSelectedObject(objects)
    }

    render(){
        const { visible } = this.props
        let { selected_object } = this.props
        if (!visible) selected_object = []
        
        return (
            <Modal
                visible = {visible}
                title = "Lựa chọn đối tượng"
                onOK={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                width={900}
                footer={
                    null
                }
            >
                <SelectObjectComponent 
                    onSuccess = {(objects) => this._userSelectObject(objects)}
                    onCancel = {() => this._handleCancel()}
                    initObject = {selected_object}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbreport.modalSelectObjectState,
        selected_object: state.qbreport.selected_object
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalSelectObject())
        },
        updateSelectedObject: selected_object => {
            dispatch(ReportActions.action.updateSelectedObject(selected_object))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectObject)